import React from 'react';

// Styles
import './SidebarTitle.scss';

function SidebarTitle({ title }: { title: string }) {
  return <h4 className='admin-2-estimates__sidebar-title'>{title}</h4>;
}

export default SidebarTitle;
